module.exports = __webpack_public_path__ + "media/country_flags/qa-23e08d22.png";